module.exports = __webpack_public_path__ + "static/media/CopyIcon.2bdb3d51.svg";